import { useState } from "react"
import { Formik, Form } from "formik"
import * as Yup from "yup"
import Modal from "./Modal"
import TextField from "./TextField"
import { X } from "@phosphor-icons/react"

const validationSchema = Yup.object({
  errorCode: Yup.string().max(100, "Error code must be at most 100 characters"),
  errorDesc: Yup.string(),
}).test(
  "at-least-one-field",
  "At least one field (errorCode or errorDesc) must be provided",
  function (values) {
    return values.errorCode || values.errorDesc
  }
)

const ErrorCodesMappingModal = ({
  isOpen,
  onClose,
  onSubmit,
  initialData,
  isEditing,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = async (values) => {
    setIsSubmitting(true)
    try {
      await onSubmit(values)
      onClose()
    } catch (error) {
      console.error("Error submitting form:", error)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-gray-900">
          {isEditing ? "Edit Error Code Mapping" : "Create Error Code Mapping"}
        </h2>
        <button
          className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full"
          onClick={onClose}
        >
          <X size={20} />
        </button>
      </div>

      <Formik
        enableReinitialize
        initialValues={{
          errorCode: initialData?.errorCode || "",
          errorDesc: initialData?.errorDesc || "",
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        <Form className="space-y-4">
          <TextField
            autofocus={!isEditing}
            label="Error Code"
            name="errorCode"
            placeholder="Enter error code (max 100 characters)"
          />

          <TextField
            label="Error Description"
            name="errorDesc"
            placeholder="Enter error description"
          />

          <div className="flex gap-3 pt-4">
            <button
              className="flex-1 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              type="button"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              className="flex-1 px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={isSubmitting}
              type="submit"
            >
              {isSubmitting ? "Saving..." : isEditing ? "Update" : "Create"}
            </button>
          </div>
        </Form>
      </Formik>
    </Modal>
  )
}

export default ErrorCodesMappingModal
